<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">{{ data.title }}</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>

<div mat-dialog-content>
    <ng-select
        #itemSelect
        [items]="data.items"
        [bindLabel]="data.bindLabel"
        [bindValue]="data.bindValue"
        [searchFn]="data.searchFn"
        [clearable]="false"
        appendTo="body"
        [placeholder]="data.placeholder ?? 'Zoeken...'"
        (change)="select($event)">
    </ng-select>
</div>
